import Search from "../pages/DSC_partial_Search";
import Dashboard from "../pages/DSC_partial_Dashboard";
import ClientDebtSummary from "../pages/DSC_partial_ClientDebtSummary";
import Breadcrumbs from '../../src/components/Breadcrumbs';

const DebtSettlementCalculator = () => {
  return (
      <div className="app-container">
         <div className="container">
            <h1>Debt Settlement Calculator</h1>
            <Breadcrumbs />
            <div className="notif-reminder">
              <strong>WARNING: </strong> 
              <span> This page is currently for testing purposes only. Please contact development team for any concerns.</span>
            </div>
            <Dashboard />
            <div className="app-column">
                <ClientDebtSummary />
            </div>
            <label className="custom-footer">© 2025 Pacific Debt Relief. All rights reserved. </label>
            <br/> <br/> <br/> <br/>
          </div> 
      </div>
  );
};

export default DebtSettlementCalculator;